<template>
    <div id="answer">
        <div class="app-container mb-5" v-if="!$global.loading">

            <!-- Titre -->
            <div class="d-flex justify-content-between mb-5">
                <div class="d-flex" v-if="!$global.loading">
                    <div class="category-btn mr-3">
                        {{ provider.category.label }}
                    </div>

                    <div class="page-title mr-3">
                        <router-link :to="'/summary/' + getB64(provider.provider.id)">
                            {{ cardName }}
                        </router-link>
                    </div>

                    <v-icon>keyboard_arrow_right</v-icon>

                    <div class="page-title">
                        <span class="breadcrumb-item">
                      Information reçue
                            <span v-if="aspect">
                                        - {{ aspectLabel }}
                                    </span>
                    </span>
                    </div>
                </div>

                <div class="d-flex justify-content-between">
                    <div>
                        <v-btn outlined class="custom-button-primary mr-5" target="_blank" @click="prepareDraft">
                            <v-icon left>edit</v-icon>
                            INTEGRER EN BROUILLON
                        </v-btn>
                    </div>
                </div>
            </div>

            <div class="container-fluid">
                <div class="row">
                    <!-- Contexte -->
                    <v-card class="mb-5 mr-4 col">
                        <div class="p-4">
                            <h3 class="mb-5" v-if="campaign !== null">
                                Campagne
                                <span v-if="campaign.aspect">
                                        {{ aspectLabel }}
                                    </span>
                                <router-link :to="'/campaign/cmaj/' + getB64(campaign.id)">{{ campaign.name }}
                                </router-link>
                            </h3>
                            <div>

                                <div class="d-flex mb-4">
                                    <v-icon left color="primary" large>
                                        account_box
                                    </v-icon>
                                    <h5>
                                        <b>{{ answer.first_name }} {{ answer.last_name }}</b> (<a
                                      :href="'mailto:' + answer.email + '?subject=Au sujet de ' + provider.name">{{
                                            answer.email
                                        }}</a>)
                                    </h5>
                                </div>

                                <div class="d-flex mb-4">
                                    <v-icon left color="primary" large>
                                        archive
                                    </v-icon>
                                    <h5>
                                        Reçue le {{ formatDate(answer.updated_at) }} —
                                        <a class="mt-2"
                                           :href="apiUrl + '/export-to-pdf/cmaj/' + answer.id + '/' + selectLast">
                                            Télécharger le PDF
                                        </a>
                                    </h5>
                                </div>

                                <div class="d-flex mb-4" v-if="answer.web_form.state.code === 'TREATED'">
                                    <v-icon left color="primary" large>
                                        fact_check
                                    </v-icon>
                                    <h5>
                                        Réponse traitée
                                    </h5>
                                </div>

                                <div class="mt-5 pt-5 text-center" v-if="answer.web_form.state.code !== 'TREATED'">
                                    <v-btn class="default-button" @click="saveBeforeTreat">
                                        Marquer la réponse comme traitée
                                    </v-btn>
                                </div>
                            </div>
                        </div>
                    </v-card>
                </div>
            </div>

            <!-- Erreurs & warnings -->
            <div class="mb-5">
                <div v-if="!answer.open_this_season">
                    <v-alert type="warning" text>
                        Le prestataire déclare avoir cessé cette activité.
                    </v-alert>
                </div>
            </div>

            <!-- Réponse complète -->
            <div class="p-4 mb-5 bg-white rounded mr-auto ml-auto" v-if="answer.open_this_season">

                <v-stepper @change="setSitAnswerCurrentStep" non-linear :value="sitAnswerCurrentStep"
                           class="h-auto w-auto config-stepper mb-5">
                    <v-stepper-header>
                        <v-stepper-step editable step="1">
                            <div class="d-flex">
                                <v-icon class="mr-2">compare_arrows</v-icon>
                                <span>Différences</span>
                            </div>
                        </v-stepper-step>
                        <v-stepper-step editable step="2">
                            <div class="d-flex">
                                <v-icon class="mr-2">reorder</v-icon>
                                <span>Réponse complète</span>
                            </div>
                        </v-stepper-step>
                    </v-stepper-header>

                    <v-stepper-items>
                        <v-stepper-content class="pt-0" step="1">
                            <sit-answer-diffs-step
                              :languages="languages">
                            </sit-answer-diffs-step>
                        </v-stepper-content>
                        <v-stepper-content class="pt-0" step="2">
                            <sit-global-answer-step
                              :languages="languages"
                              :contacts="contacts"
                              :professions="professions">
                            </sit-global-answer-step>
                        </v-stepper-content>
                    </v-stepper-items>
                </v-stepper>
            </div>

            <!-- Retour en haut -->
            <div id="up-scroll" @click="scrollTop">
                <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">
                            <v-icon class="white--text">keyboard_arrow_up</v-icon>
                        </span>
                    </template>
                    <span>Retour en haut</span>
                </v-tooltip>
            </div>
        </div>

        <div v-if="!$global.loading && errorMessage !== null" class="mt-5 mb-5 app-container">
            <v-alert type="error" text border="right" colored-border>
                {{ errorMessage }}
            </v-alert>
        </div>

        <v-dialog v-model="takeDraftModal" width="700px" v-if="draft !== null">
            <take-power-back-modal :draft="draft"></take-power-back-modal>
        </v-dialog>
    </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex"
import SitGlobalAnswerStep from "./sit-answer-steppers/SitGlobalAnswerStep.vue"
import SitAnswerDiffsStep from "./sit-answer-steppers/SitAnswerDiffsStep.vue"
import CreateOfferModal from "../cadhConfiguration/steppers/CreateOfferModal.vue"
import TakePowerBackModal from "../tools/TakePowerBackModal.vue"

export default {
    name: "SitAnswer",
    components: {
        CreateOfferModal,
        SitGlobalAnswerStep,
        SitAnswerDiffsStep,
        TakePowerBackModal,
    },
    data() {
        return {
            token: null,
            answer: null,
            provider: null,
            contacts: [],
            languages: [],
            professions: [],
            apiUrl: process.env.VUE_APP_API_URL,
            lastWrite: null,
            lastModification: null,
            selectLast: false,
            campaign: null,
            errorMessage: null,
            multiHours: false,
            draft: null,
            takeDraftModal: false,
            cardName: "",
        }
    },
    methods: {
        ...mapMutations("web_form", [
            "resetState",
            "setProvider",
            "setFields",
            "setDisabled",
            "setFamilyElements",
            "setExtra",
            "setCurrencies",
            "setCategoryFamilies",
            "setAspect",
            'setSourcesLoaded',
            'setSuggestedMedias',
        ]),
        ...mapMutations("sitAnswer", [
            "setSitAnswerCurrentStep",
            "setDiffs",
        ]),
        getAnswer() {
            this.$global.loading = true

            this.$http.get("webform/answer/" + this.token + "/" + this.selectLast).then(res => {
                if (res.body.success) {
                    let provider = res.body.data.provider
                    this.answer = res.body.data.answer
                    this.campaign = res.body.data.campaign

                    let lastWriteAction = res.body.data.lastWriteAction
                    let lastModificationAction = res.body.data.lastModificationAction

                    if (lastWriteAction !== null) {
                        this.lastWrite = this.$moment(lastWriteAction.pivot.created_at).format("DD-MM-YYYY à HH[h]mm")
                    }

                    if (lastModificationAction !== null) {
                        this.lastModification = this.$moment(lastModificationAction.pivot.created_at).format("DD-MM-YYYY à HH[h]mm")
                    }

                    this.formatProviderData(provider)

                    this.setProvider(provider)
                    this.setFields(res.body.data.fields)
                    this.setFamilyElements(res.body.data.referential)
                    this.setExtra(this.answer.extra)
                    this.setCategoryFamilies(res.body.data.categoryFamilies)
                    this.setDiffs(res.body.data.diffs)
                    this.cardName = res.body.data.referentName

                    this.provider = provider
                    this.setAspect(this.provider.aspect)

                    document.title = "Dahub – " + this.provider.name

                    if (this.diffs.length === 0) {
                        this.setSitAnswerCurrentStep("2")
                    }

                    this.$global.loading = false
                } else if (res.body.code === 404) {
                    this.errorMessage = "La fiche n'existe plus sur Dahub. Elle a du être supprimée depuis le tableau" +
                      " des prestataires. La réponse associée à cette fiche n'est donc plus disponible."

                    this.$global.loading = false
                    this.loaded = true
                }
            })
        },
        formatProviderData(provider) {
            this.formatPricePeriods(provider)
        },
        formatPricePeriods(provider) {
            provider.price_periods.forEach(period => {
                period.prices.forEach(price => {
                    let mode = "MIN_MAX"

                    if (price.min === price.max) {
                        mode = "UNIQUE"
                    } else if (price.max === null) {
                        mode = "FROM"
                    }

                    price.min = price.min / 100
                    price.max = price.max / 100

                    price.mode = mode
                })
            })
        },
        getCommunicationTypes() {
            this.$http.get("resource/communication-types").then(res => {
                this.contacts = res.body.data.contacts
            })
        },
        saveBeforeTreat() {
            this.$forceUpdate()

            this.$global.loading = true
            this.selectLast = true

            setTimeout(() => {
                this.treatAnswer()
            }, 500)
        },
        prepareDraft() {
            this.$http.get("sitform/check-draft/" + this.provider.provider.id).then(res => {
                if (res.body.success) {
                    this.$router.push({
                        path: "/sit/formulaire/" + this.provider.provider.id,
                        query: {
                            providerDataId: this.provider.id,
                            newDraft: true,
                            fromAnswer: this.answer.id,
                        },
                    })
                } else {
                    let webForm = res.body.data.webForm
                    this.draft = {
                        user_name: webForm.user.last_name,
                        user_first_name: webForm.user.first_name,
                        user_id: webForm.user.id,
                        drafted_at: webForm.answer.drafted_at,
                        provider_data_id: webForm.answer.provider_data_versions[0].id,
                        web_form_id: webForm.id,
                        provider_id: this.provider.provider.id,
                    }

                    this.takeDraftModal = true
                }
            })
        },
        write() {
            let payload = {
                answerId: this.answer.id,
                providerDataId: this.provider.id,
                skipSso: false,
                criterias: this.selectedCriterias,
                multiHours: this.multiHours,
            }

            this.$http.post("auth/answers/write/quebec", payload).then(res => {
                this.$global.loading = false

                this.$store.dispatch("account/getUskaNotificationsCount")
            })
        },
        getLanguages() {
            this.$http.get("resource/languages").then(res => {
                this.languages = res.body.data.languages
            })
        },
        getProfessions() {
            this.$http.get("resource/professions").then(res => {
                this.professions = res.body.data.professions
            })
        },
        getCurrencies() {
            this.$http.get("resource/currencies").then(res => {
                this.setCurrencies(res.body.data.currencies)
            })
        },
        getInternalCriterias() {
            this.$http.get("auth/account/apidae-criterias").then(res => {
                this.criterias = res.body.data.criterias
            })
        },
        getB64(id) {
            return btoa(id)
        },
        treatAnswer() {
            this.$global.loading = true

            this.$http.get("auth/webform/treat/answer/" + this.answer.id).then(res => {
                this.answer.web_form.state = res.body.data.state

                this.$store.dispatch("account/getUskaNotificationsCount")

                this.$global.loading = false
            })
        },
        scrollTop() {
            window.scroll({
                top: 0,
                left: 0,
                behavior: "smooth",
            })
        },
    },
    computed: {
        ...mapState("account", [
            "account",
            "vtContract",
            "user",
        ]),
        ...mapState("sitAnswer", [
            "sitAnswerCurrentStep",
            "diffs",
        ]),
        ...mapState("web_form", [
            "aspect",
        ]),
        ...mapGetters("web_form", [
            "hasField",
            "hasFamilyElement",
            "getFamilyByCode",
            "getElementsByFamilyCode",
        ]),
        aspectLabel() {
            if (this.aspect) {
                if (this.aspect === "business") {
                    return "Tourisme d'affaires"
                } else if (this.aspect === "winter") {
                    return "Hiver"
                } else if (this.aspect === "summer") {
                    return "Été"
                }
            }
        },
    },
    created() {
        this.token = this.$route.params.token

        this.resetState()
        this.setDisabled(true)

        this.getAnswer()
        this.getCommunicationTypes()
        this.getLanguages()
        this.getProfessions()
        this.getCurrencies()
        this.setSourcesLoaded(true)
        this.setSuggestedMedias([])

        this.$global.$on("close_take_power_back_modal", () => {
            this.takeDraftModal = false
        })
    },
}
</script>
